module.exports = __webpack_public_path__ + "static/media/Turkey.608a6f55.jpg";